import { render, staticRenderFns } from "./SelectIdentity.vue?vue&type=template&id=378239da&scoped=true"
import script from "./SelectIdentity.vue?vue&type=script&lang=js"
export * from "./SelectIdentity.vue?vue&type=script&lang=js"
import style0 from "./SelectIdentity.vue?vue&type=style&index=0&id=378239da&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378239da",
  null
  
)

export default component.exports